export default __webpack_public_path__ + "assets/images/0abdb3e3ac4bc43068c366c4f8a36549.webp";